import { render } from "./MobileGalleryComponent.vue?vue&type=template&id=1ed8c166&scoped=true"
import script from "./MobileGalleryComponent.vue?vue&type=script&lang=js"
export * from "./MobileGalleryComponent.vue?vue&type=script&lang=js"

import "./MobileGalleryComponent.vue?vue&type=style&index=0&id=1ed8c166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed8c166"]])

export default __exports__